import lenoxData from "./lenoxData.js"
import commonFunctions from "./commonFunctions.js"

var engravingsURL = function (productID,
                              width,
                              height,
                              textStrings) {
    return createEngravingURL(productID, width, height, textStrings, lenoxData.lenoxVignetteTable_2, lenoxData.lenoxProductTable_2);
};

var gemstonesURL = function (productID, width, height, stones) {
    return createGemURL(productID, width, height, stones, lenoxData.lenoxVignetteTable_1, lenoxData.lenoxProductTable_1);

};

var gemstonesURL2 = function (productID, width, height, stones) {
    return createGemURL(productID, width, height, stones, lenoxData.lenoxVignetteTable_1, lenoxData.lenoxProductTable_7);
};

var snowFlakeURL = function (productID, width, height, items, textStrings) {
    var snowURL = createSnowFlakeURL(productID, width, height, items, lenoxData.lenoxVignetteTable_4, lenoxData.lenoxProductTable_4);
    var textURL = createEngravingURL(productID, width, height, textStrings, lenoxData.lenoxVignetteTable_4text, lenoxData.lenoxProductTable_4);
    return snowURL + textURL;
};

var gemstonestextURL = function (productID, width, height, stones, textStrings) {
    var stonesURL = createGemURL(productID, width, height, stones, lenoxData.lenoxVignetteTable_3gem, lenoxData.lenoxProductTable_3);
    var textURL = createEngravingURL(productID, width, height, textStrings, lenoxData.lenoxVignetteTable_3text, lenoxData.lenoxProductTable_3);

    return stonesURL + textURL;
};

var createEngravingURL = function (productID,
                                   width,
                                   height,
                                   textStrings,
                                   vignetteTable,
                                   productTable) {
    var engravingsUrl = getFirstPart(productID, width, height, vignetteTable, productTable);

    var currText;
    var numSubstitutions = commonFunctions.getNumFeatures(productID, vignetteTable, productTable);

    // handle special engravings
    if (productID == "7380" || productID == "7390") {

        // break up single line into up to 12 lines of a single character for vertical text
        textStrings = convertSingleLineToMultiLine(textStrings[0], 12);
        numSubstitutions = 12;

    } else if (productID == "6079") {
        // break up monogram in form of 2-1-3
        textStrings = convertSingleLineToMultiLine(textStrings[0], 3);
        numSubstitutions = 3;
        //} else if ( productID == "22566-block" || productID == "22566-script") {
    } else if (isNaN(productID)) {
        if (productID.indexOf("-block") > 0 || productID.indexOf("-script") > 0) {
            // break up monogram in form of 2-1-3
            textStrings = convertSingleLineToMultiLine(textStrings[0], 3);
            numSubstitutions = 3;
        }
    }

    for (var i = 0; i < numSubstitutions; i++) {
        currText = textStrings[i];
        var regExp = new RegExp("\\$" + (i + 1) + "\\$", "g");
        engravingsUrl = engravingsUrl.replace(regExp, currText);
    }

    return engravingsUrl;
};

var createGemURL = function (productID, width, height, stones, vignetteTable, productTable) {
    var stonesUrl = getFirstPart(productID, width, height, vignetteTable, productTable);
    var gemTable = commonFunctions.getGemTable(productID);

    if (productID == "12955" || productID == "16551") {
        var gemColor = commonFunctions.getItemRGBColor(stones[0], gemTable);
        if (gemColor.indexOf(",") == -1)
            stonesUrl += "&obj=g1/" + gemColor + "&show" + "&obj=g1/facet&hide";
        else
            stonesUrl += "&obj=g1/facet&show" + "&color=" + gemColor;

        cutLength = stones.length;
        stones.slice(1, cutLength);
        stones.reverse();

        maxLength = stones.length - 1;

        for (var i = 0; i < maxLength; i++) {
            var gemColor = commonFunctions.getItemRGBColor(stones[i], gemTable);
            if (gemColor.indexOf(",") == -1)
                stonesUrl += "&obj=g" + (i + 2) + "/" + gemColor + "&show" + "&obj=g" + (i + 2) + "/facet&hide";
            else
                stonesUrl += "&obj=g" + (i + 2) + "/facet&show" + "&color=" + gemColor;
        }

    } else {
        for (var i = 0; i < stones.length; i++) {
            if (stones[i] == commonFunctions.NO_STONE_LABEL || stones[i] == "") {
                stonesUrl += "&obj=g" + (i + 1) + "&hide";
            } else {
                var gemColor = commonFunctions.getItemRGBColor(stones[i], gemTable);

                if (productID == "17079") {
                    if (gemColor.indexOf(",") == -1) {
                        stonesUrl += "&obj=g" + (i + 1) + "/" + gemColor + "&show";
                    } else {
                        stonesUrl += "&obj=g" + (i + 1) + "/facet&show";
                    }
                } else {
                    if (gemColor.indexOf(",") == -1) {
                        stonesUrl += "&obj=g" + (i + 1) + "/" + gemColor + "&show" + "&obj=g" + (i + 1) + "/facet&hide";
                    } else {
                        stonesUrl += "&obj=g" + (i + 1) + "/facet&show" + "&color=" + gemColor;
                    }
                }
            }
        }
    }
    stonesUrl += "&op_usm=1,10,0,0";

    return stonesUrl;
};

var createSnowFlakeURL = function (productID, width, height, stones, vignetteTable,
                                   productTable) {
    var stonesUrl = getFirstPart(productID, width, height, vignetteTable, productTable);
    var gemTable = commonFunctions.getGemTable(productID);

    for (var i = 0; i < stones.length; i++) {
        if (stones[i] == commonFunctions.NO_ORNAMENT_LABEL || stones[i] === "") {
            stonesUrl += "&obj=g" + (i + 1) + "&hide";
        } else {
            var gemColor = commonFunctions.getItemRGBColor(stones[i], gemTable);

            if (gemColor.indexOf(",") == -1) {
                stonesUrl += "&obj=g" + (i + 1) + "/" + gemColor + "&show";
            }
        }
    }
    stonesUrl += "&op_usm=1,10,0,0";

    return stonesUrl;
};

var convertSingleLineToMultiLine = function (textString, maxCharacters) {
    var text = new Array(maxCharacters);
    /*
     if (textString.length < maxCharacters) {
     var pad = (maxCharacters - textString.length) / 2.0;
     alert(pad);
     var padding= "";
     for (var i = 0; i < pad; i++)
     padding += " ";
     alert(padding);
     textString = padding + textString;
     }
     */
    for (var i = 0; i < maxCharacters; i++) {
        if (i < textString.length)
            text[i] = textString.charAt(i);
        else
            text[i] = "";
    }
    return text;
};

var getFirstPart = function (productID, width, height, vignetteTable, productTable) {
    var firstPart = commonFunctions.getVignetteUrlFragment(productID, vignetteTable, productTable);

    try {
        firstPart = firstPart.replace(/wid=\d+/, "wid=" + width);
        firstPart = firstPart.replace(/hei=\d+/, "hei=" + height);
    }
    catch(err) {
        firstPart = '';
    }

    return firstPart;
};

var populateGemCountSelector = function (pSelector, gcSelector, pTable, vTable) {
    var selectedProductId = commonFunctions.getSelectedProductId(pSelector, pTable);
    var totalPossGems = commonFunctions.getNumFeatures(selectedProductId, vTable, pTable);

    gcSelector.options.length = 0;
    for (var i = 0; i < totalPossGems; i++) {
        gcSelector.options[i] = new Option(i + 1);
    }
};

var colorizedGemCountURL = function (selectedProductId, numGems, controlIdPrefix) {
    var url = "";
    var selectedProductSku = commonFunctions.lookupSku(selectedProductId, lenoxData.lenoxProductTable_5);
    for (var i = 0; i < lenoxData.lenoxVignetteTable_5.length; i++) {
        if (selectedProductSku == lenoxData.lenoxVignetteTable_5[i][commonFunctions.productDisplayNameInd]) {
            url = lenoxData.lenoxVignetteTable_5[i][1][numGems - 1];
            break;
        }
    }

    var gemTable = commonFunctions.getGemTable(selectedProductId);
    for (var j = 0; j < numGems; j++) {
        var currControl = document.getElementById(controlIdPrefix + (j + 1));
        var gemName = currControl.options[currControl.selectedIndex].text;
        var gemColor = commonFunctions.getItemRGBColor(gemName, gemTable);
        if (gemName == commonFunctions.NO_STONE_LABEL)
            url = url.replace("0,0,0", "r,g,b");
        else {
            var gemColor = commonFunctions.getItemRGBColor(gemName, gemTable);

            if (gemColor.indexOf(",") == -1)
                url = url.replace("facet&show&color=0,0,0", gemColor + "&show");
            else
                url = url.replace("0,0,0", gemColor);
        }
    }

    return url.replace(/r,g,b/g, "0,0,0");
};

var monogrammedHeartCountURL = function (selectedProductId, numHearts, controlIdPrefix, pTable, vTable, gSelector) {
    var url = "";
    var selectedProductSku = commonFunctions.lookupSku(selectedProductId, pTable);
    for (var i = 0; i < vTable.length; i++) {
        if (selectedProductSku == vTable[i][commonFunctions.productDisplayNameInd]) {
            url = vTable[i][1][numHearts - 1];
            break;
        }
    }

    if (gSelector != null) {

        var selectedMonth = gSelector.options[gSelector.selectedIndex].text;

        if (url.indexOf("obj=GEMS") != -1) {
            if (selectedMonth == commonFunctions.NO_STONE_LABEL)
                url = url.replace(/&obj=GEMS\/\$month&show/, "");
            else
                url = url.replace("$month", lenoxData.monthTable[selectedMonth]);
        } else {
            var gemTable = commonFunctions.getGemTable(selectedProductId);
            var gemColor = commonFunctions.getItemRGBColor(selectedMonth, gemTable);
            url = url.replace("0,0,0", gemColor);
        }

    }

    for (var j = 0; j < numHearts; j++) {
        var currControl = document.getElementById(controlIdPrefix + (j + 1));
        var monogram = currControl.value;
        url = url.replace(/\$text=\w*&/, "$texxxt=" + monogram + "&");
    }

    return url.replace(/texxxt=/g, "text=");
};

var enableControlsByCount = function (gemCountSelector, numControls, controlIdPrefix, isTextControl) {
    var gemCount = gemCountSelector.options[gemCountSelector.selectedIndex].text;
    commonFunctions.enableControls2(numControls, gemCount, controlIdPrefix, isTextControl);
};

var currentCount = 1;
var currentGems = ["JAN"];
var selectorsHTML = "<TR><TD align=middle>1</TD><TD><SELECT onchange=window.focus();setGem(1);previewImage(); name=StoneName01 id=cbStone1 /></TD></TR>";

var setGem = function (ind) {
    var gemSel = document.getElementById("cbStone" + ind);
    currentGems[ind - 1] = gemSel.options[gemSel.selectedIndex].text;
};

var addStone = function (pSelector, pTable, vTable, baseId) {
    var productID = commonFunctions.getSelectedProductId(pSelector, pTable);
    var maxStones = commonFunctions.getNumFeatures(productID, vTable, pTable);
    if (currentCount == maxStones)
        return;

    currentGems.splice(currentCount, 0, "JAN");
    currentCount += 1;
    var selectorsElem = document.getElementById("gemSelectors");
    selectorsHTML += "<TR><TD align=middle>" + currentCount + "</TD><TD><SELECT onchange=window.focus();setGem(" + currentCount + ");previewImage(); name=StoneName01 id=cbStone" + currentCount + " /></TD></TR>";
    selectorsElem.innerHTML = "<TABLE><TBODY>" + selectorsHTML + "</TBODY></TABLE>";

    populateCurrGemSelectors(pSelector, pTable, baseId);

    for (var i = 0; i < currentCount; i++) {
        var currSel = document.getElementById("cbStone" + (i + 1));
        for (var j = 0; j < currSel.options.length; j++) {
            if (currSel.options[j].text == currentGems[i]) {
                currSel.selectedIndex = j;
                break;
            }
        }
    }
};

var resetControls = function (pSelector, pTable, baseId) {
    currentCount = 1;
    currentGems = ["JAN"];

    var gemsSelElem = document.getElementById("gemSelectors");
    selectorsHTML = "<TR><TD align=middle>1</TD><TD><SELECT onchange=window.focus();setGem(1);previewImage(); name=StoneName01 id=cbStone1 /></TD></TR>";
    gemsSelElem.innerHTML = "<TABLE><TBODY>" + selectorsHTML + "</TBODY></TABLE>";
    populateCurrGemSelectors(pSelector, pTable, baseId);
};

var populateCurrGemSelectors = function (pSelector, pTable, baseId) {
    commonFunctions.populateGemSelectors2(pSelector, pTable, baseId, currentCount);
};

var getCurrStonesArray = function (selectedProduct, vignetteTable, productTable, baseId) {
    var selectedProductSku = commonFunctions.lookupSku(selectedProduct, productTable);

    var stoneName;
    var stones = new Array(currentCount);
    for (var i = 0; i < currentCount; i++) {
        selector = document.getElementById(baseId + (i + 1));
        selectedIndex = selector.selectedIndex;
        if (selectedIndex == -1)
            selectedIndex = 0;
        stoneName = selector.options[selectedIndex].text;
        stones[i] = stoneName;
    }

    var first = stones.shift();
    stones.reverse();
    stones.unshift(first);

    return stones;
};
//regScene7 = function(){
/**
 * New functions 2015 using global scene7 object
 */

// main public function
// example: var myUrl = lenoxData.scene7.getUrl("123456", "MONOFRONT", ["X","Y","Z"], ["OLDENGLISH"]);
lenoxData.scene7.getUrl = function (sku, style, textArray, fontArray) {
    var baseUrl = lenoxData.scene7._getBaseUrl(sku, style);
    if (baseUrl !== "" && baseUrl !== undefined && baseUrl !== null) {

        // check if there is an URL exception
        var exceptionCase = lenoxData.scene7._getExceptionCase(baseUrl);
        if (exceptionCase.hasException) {
            var exceptionCode = exceptionCase.code;
            baseUrl = exceptionCase.url;
            return lenoxData.scene7._exceptionCases[exceptionCode](baseUrl, textArray, fontArray);
        } else
            return lenoxData.scene7._getFinalUrl(baseUrl, textArray, fontArray);
    } else {
        var msg = "Scene7 error: %SKU%:%STYLE% is missing or undefined in lenoxData.js"
            .replace(/%SKU%/, sku)
            .replace(/%STYLE%/, style);
        throw msg;
        return false;
    }
};

// INTERNAL METHODS
// internal method which fetches base URL from data
lenoxData.scene7._getBaseUrl = function (sku, style) {
    var url = "";
    try {
        url = lenoxData.scene7.styles[sku][style];
    } catch (e) {
        lenoxData.scene7._s7Log("Error: SKU or Style does not exist!");
    }
    return url;
};

// internal method  to get actual font names from array of font name objects
lenoxData.scene7._getFontArray = function (fontObjArray) {
    var fontArray = [];
    if (fontObjArray.length > 0) {
        for (var i = 0; i < fontObjArray.length; i++) {
            // check if array element is blank
            var font = (fontObjArray[i] !== null && fontObjArray[i] !== undefined)
                ? lenoxData.scene7._getFontName(fontObjArray[i])
                : "";
            fontArray.push(font);
        }
    } else fontArray.push("");
    return fontArray;
};

// internal method to get font from table; input is object {"CHOICE" : "VALUE"}
lenoxData.scene7._getFontName = function (fontNameObj) {
    // get key name and value from simple object
    var fontType, fontName, s7fontName = "";
    for (fontType in fontNameObj) {
        fontName = fontNameObj[fontType];
        break; // only run once, in case there are additional properties
    }
    try {
        s7fontName = lenoxData.scene7.fontTable[fontType][fontName] || '';
    } catch (e) {
        lenoxData.scene7._s7Log("Error: Font lookup values are not valid!");
    }
    return s7fontName;
}

// main internal method which accepts an array of text strings and font names, and inserts them into the URL and returns result
lenoxData.scene7._getFinalUrl = function (baseUrl, textArray, fontObjArray) {
    // parse font object array and return internal Scene7 name of font
    var fontArray = lenoxData.scene7._getFontArray(fontObjArray);
    // substitute text
    var arrayIdx = 0, stringIdx = 0, regEx = /\$(?:text\d?)=(.+?)\}?\&/i, result, tempStr, finalUrl = "";
    // replace text strings
    for (arrayIdx = 0; arrayIdx < textArray.length; arrayIdx++) {
        result = regEx.exec(baseUrl.slice(stringIdx));
        var text = encodeURIComponent(textArray[arrayIdx]);
        // if text is blank, substitute a space character
        text = (text === "") ? "%20" : text;
        if (result !== null && result !== "") {
            stringIdx += result.index + result[0].length;
            var input = result.input;
            tempStr = input.substr(0, result.index + result[0].length);
            finalUrl += tempStr.replace(/(\$text\d?=)(.+?)(\}?\&)/i, "$1" + text + "$3");
        }
    }
    finalUrl += baseUrl.slice(stringIdx);
    // replace fonts
    regEx = /(\$font\d?=)(.+?)(\}?\&)/i;
    for (var arrayIdx = 0; arrayIdx < fontArray.length; arrayIdx++) {
        // get nested substring and then search for font inside that
        var nestedUrlObj = lenoxData.scene7._getNestedUrl(finalUrl, arrayIdx);
        finalUrl = nestedUrlObj["start"];
        // if font name is blank, do not substitute font
        if (fontArray[arrayIdx] !== "") {
            // search substring for font expression and make replacement
            finalUrl += nestedUrlObj["match"].replace(regEx, "$1" + encodeURIComponent(fontArray[arrayIdx]) + "$3");
            // now add font exceptions if there are any
            var exceptionStr = lenoxData.scene7._getFontExceptions(fontArray[arrayIdx]);
            if (exceptionStr !== "") {
                // get nested substring and add font exception at end
                finalUrl = lenoxData.scene7._putFontExceptions(finalUrl, exceptionStr);
            }
        } else
            finalUrl += nestedUrlObj["match"];
        finalUrl += nestedUrlObj["end"];
    }
    lenoxData.scene7._s7Log("Final URL\n" + finalUrl);
    return finalUrl;
};

// After finalUrl is created, inserts exception string before closing bracket
lenoxData.scene7._putFontExceptions = function (url, exceptionStr) {
    return returnUrl = url.slice(0, url.length - 1) + exceptionStr + url.slice(url.length - 1);
};

// regex helper which extracts bracketed section depending on current font index
// returns nested section, first part of URL and last part of URL
// if arrayIdx is -1, return number of matches
lenoxData.scene7._getNestedUrl = function (url, arrayIdx) {
    var regEx = /(\{|\()(.*?)(\}|\))/g,
        result, countIdx = 0,
        returnUrl = "",
        startStr = "",
        endStr = "";
    while ((result = regEx.exec(url)) !== null) {
        if (arrayIdx === countIdx) {
            returnUrl = result[0];
            startStr = url.slice(0, result.index);
            endStr = url.slice(startStr.length + returnUrl.length);
        }
        countIdx++;
    }
    // make sure returnUrl isn't blank
    returnUrl = (returnUrl !== "") ? returnUrl : url;
    return {
        "match": returnUrl,
        "start": startStr,
        "end": endStr,
        "count": countIdx
    };
};

// resolves font exceptions from lookup table
lenoxData.scene7._getFontExceptions = function (fontName) {
    var urlString = "";
    try {
        var exception = lenoxData.scene7.fontExceptions[fontName];
        urlString = (exception !== undefined && exception !== null) ? exception : "";
    } catch (e) {
        lenoxData.scene7._s7Log("Error: Font exception lookup caused by " + fontName);
        throw e;
    }
    return urlString;
};

// checks if there is a URL exception and returns true/false, exception code and url
lenoxData.scene7._getExceptionCase = function (url) {
    var hasException = false;
    // see if text at end of URL ends in ".caseX" and case exists in table
    var codeStrLen = "&.caseX".length,
        caseCode = url.slice(-codeStrLen).slice(2);
    try {
        hasException = (!!lenoxData.scene7._exceptionCases[caseCode]);
        // remove case string from url
        url = (hasException) ? url.slice(0, -codeStrLen) : url;
    } catch (e) {
        lenoxData.scene7._s7Log("Error: Font exception lookup caused by " + caseCode);
        throw e;
    }
    return {"hasException": hasException, "code": caseCode, "url": url};
};

// logic for handling URL-level exceptions
lenoxData.scene7._exceptionCases = {
    // case1: Same text and/or font may need to be substituted multiple times
    // text and font strings in URL should be substituted with $1$ variables
    "case1": function (baseUrl, textArray, fontObjArray) {
        var finalUrl = baseUrl, arrayIdx = 0,
            regExStr = "(\\$text\\d?=)\\$(IDX)\\$(\\}?\\&)";
        // replace text strings
        for (arrayIdx = 0; arrayIdx < textArray.length; arrayIdx++) {
            var text = encodeURIComponent(textArray[arrayIdx]);
            // if text is blank, substitute a space character
            text = (text === "") ? "%20" : text;
            // search for $X$ variable, where X=arrayIdx + 1
            var regEx = new RegExp(regExStr.replace("IDX", arrayIdx + 1), "ig");
            finalUrl = finalUrl.replace(regEx, "$1" + text + "$3");
        }
        // replace font strings
        var fontArray = lenoxData.scene7._getFontArray(fontObjArray), fontExceptionArray = [],
            regExStr = "(\\$font\\d?=)\\$(IDX)\\$(\\}?\\&)";
        for (arrayIdx = 0; arrayIdx < fontArray.length; arrayIdx++) {
            // if font name is blank, do not substitute font
            if (fontArray[arrayIdx] !== "") {
                var font = encodeURIComponent(fontArray[arrayIdx]);
                // search for $X$ variable, where X=arrayIdx + 1
                var regEx = new RegExp(regExStr.replace("IDX", arrayIdx + 1), "ig");
                finalUrl = finalUrl.replace(regEx, "$1" + font + "$3");
                // store array of font exceptions
                var exceptionStr = lenoxData.scene7._getFontExceptions(fontArray[arrayIdx]);
                fontExceptionArray.push(exceptionStr);
            }
        }
        // if there are any font exceptions, replace them now one nested sequence at a time
        // count number of nested sequences
        var nestCount = lenoxData.scene7._getNestedUrl(finalUrl, -1)["count"],
            nestIdx = 0, exceptionIdx = 0;
        for (nestIdx = 0; nestIdx < nestCount; nestIdx++) {
            // get nested substring and then search for font inside that
            var nestedUrlObj = lenoxData.scene7._getNestedUrl(finalUrl, nestIdx);
            // start url
            finalUrl = nestedUrlObj["start"];
            // get exception string from array created above
            var exceptionStr = fontExceptionArray[exceptionIdx];
            if (exceptionStr !== "" && exceptionStr !== undefined) {
                // get nested substring and add font exception at end
                finalUrl += lenoxData.scene7._putFontExceptions(nestedUrlObj["match"], exceptionStr);
            } else
                finalUrl += nestedUrlObj["match"];
            // increment exception index if next entry in exception array is populated
            exceptionIdx = (fontExceptionArray[exceptionIdx + 1] !== undefined && fontExceptionArray[exceptionIdx + 1] !== null) ? ++exceptionIdx : exceptionIdx;
            // end url
            finalUrl += nestedUrlObj["end"];
        }

        lenoxData.scene7._s7Log("Final URL\n" + finalUrl);
        return finalUrl;
    }
};

// simple logger
lenoxData.scene7._s7Log = function (str) {
    var isDebug = (window.location.search.indexOf("s7debug") > 0) ? true : false;
    if (window.console && isDebug)
        console.log("***lenoxS7Functions: " + str);
};
//}


export default {
    engravingsURL: engravingsURL,
    gemstonesURL: gemstonesURL,
    gemstonesURL2: gemstonesURL2,
    snowFlakeURL: snowFlakeURL,
    gemstonestextURL: gemstonestextURL,
    createEngravingURL: createEngravingURL,
    createGemURL: createGemURL,
    createSnowFlakeURL: createSnowFlakeURL,
    convertSingleLineToMultiLine: convertSingleLineToMultiLine,
    getFirstPart: getFirstPart,
    populateGemCountSelector: populateGemCountSelector,
    colorizedGemCountURL: colorizedGemCountURL,
    monogrammedHeartCountURL: monogrammedHeartCountURL,
    enableControlsByCount: enableControlsByCount,
    selectorsHTML: selectorsHTML,
    setGem: setGem,
    addStone: addStone,
    resetControls: resetControls,
    populateCurrGemSelectors: populateCurrGemSelectors,
    getCurrStonesArray: getCurrStonesArray
};


// WEBPACK FOOTER //
// ../assets/js/personalize/preview/lenoxfunctions.js